import { IHttpClient, IHttpResponse } from "@/types/interfaces";

class FetchHttpClient implements IHttpClient {
	private getCSRFToken(): string | null {
		const cookies = document.cookie.split(';');
		for (let cookie of cookies) {
			const [name, value] = cookie.trim().split('=');
			if (name === 'csrftoken') {
				return decodeURIComponent(value);
			}
		}
		return null;
	}

	async get(url: string): Promise<IHttpResponse> {
		const response = await fetch(url);
		return {
			ok: response.ok,
			status: response.status,
			statusText: response.statusText,
			json: async () => response.json(),
		};
	}

	async post(url: string, data: any): Promise<IHttpResponse> {
		const headers: Record<string, string> = {
			"Content-Type": "application/json",
		};

		const csrfToken = this.getCSRFToken();
		if (csrfToken) {
			headers['X-CSRFToken'] = csrfToken;
		}

		const response = await fetch(url, {
			method: "POST",
			headers,
			body: JSON.stringify(data),
		});
		return {
			ok: response.ok,
			status: response.status,
			statusText: response.statusText,
			json: async () => response.json(),
		};
	}

	async put(url: string, data: any): Promise<IHttpResponse> {
		const headers: Record<string, string> = {
			'Content-Type': 'application/json',
		};

		const csrfToken = this.getCSRFToken();
		if (csrfToken) {
			headers['X-CSRFToken'] = csrfToken;
		}

		const response = await fetch(url, {
			method: 'PUT',
			headers,
			body: JSON.stringify(data)
		});
		return {
			ok: response.ok,
			status: response.status,
			statusText: response.statusText,
			json: async () => response.json()
		};
	}

	async patch(url: string, data: any): Promise<IHttpResponse> {
		const headers: Record<string, string> = {
			'Content-Type': 'application/json',
		};

		const csrfToken = this.getCSRFToken();
		if (csrfToken) {
			headers['X-CSRFToken'] = csrfToken;
		}

		const response = await fetch(url, {
			method: 'PATCH',
			headers,
			body: JSON.stringify(data)
		});
		return {
			ok: response.ok,
			status: response.status,
			statusText: response.statusText,
			json: async () => response.json()
		};
	}

	async delete(url: string): Promise<IHttpResponse> {
		const headers: Record<string, string> = {};

		const csrfToken = this.getCSRFToken();
		if (csrfToken) {
			headers['X-CSRFToken'] = csrfToken;
		}

		const response = await fetch(url, {
			method: 'DELETE',
			headers
		});
		return {
			ok: response.ok,
			status: response.status,
			statusText: response.statusText,
			json: async () => response.json()
		};
	}
}

export default FetchHttpClient;